import { render } from "./DisabledState.vue?vue&type=template&id=3c50ce6d"
import script from "./DisabledState.vue?vue&type=script&lang=js"
export * from "./DisabledState.vue?vue&type=script&lang=js"
script.render = render

export default script